const products = 
 [  
  { id: 1,
    nome : "10€ Amazon",
    img : "https://static-cdn.bidoo.com/img_prod/products/f7189.jpg",
    prezzo: 2.16,
    costoFinale : 5
  },

  { id:2,
    nome : "Mascherine 50pz",
    img: "https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcRokMDHNQhhivZr5aTlB6yJHRTjwEKpECCEOgyZSO-CqQhgJ1B5ooowJOnvyPf1JPPrEjbA4zeHNHdBNE_WXMo-c6UlKExcuNAsGnaVDBZefJZKPWeAn-ZL",
    prezzo: 8,
    costoFinale : 5.90
  },
  { id:3,
    nome : "10€ Amazon",
    img : "https://static-cdn.bidoo.com/img_prod/products/f7189.jpg",
    prezzo: 2.16,
    costoFinale : 5
  },
];

export default products;